<template>
    <b-modal :id="modalId" modal-class="modal-checkout-paywithbanktransfer" centered @shown="shown" @hidden="hide"
             no-close-on-esc no-close-on-backdrop hide-header-close hide-header hide-footer>

        <Loader _v-if="isLoadingOrder">
            <template #message>{{ $t('pages.checkout.modal_payment_processing_text') }}</template>
        </Loader>
    </b-modal>
</template>


<script>
    import {PAYMENT_METHOD_BANK_TRANSFER} from "@/consts.js"
    import Loader from "@/components/Loader"


    export default {
        components: {
            Loader,
        },

        props: {
            modalId: {
                type: String,
                required: true
            },

            total: {
                type: String,
                required: true
            },
        },

        methods: {
            hide() {
                this.$bvModal.hide(this.modalId)
            },

            showAndPay() {
                console.log('showAndPay')
                this.$bvModal.show(this.modalId)
            },

            async shown() {
                console.log('shown')
                await this.pay()
            },

            async pay() {
                this.isLoadingOrder = true

                this.$store.dispatch("cart/placeOrder", {paymentMethod: PAYMENT_METHOD_BANK_TRANSFER})
                    .then(response => {
                        console.log('response', response)
                        this.isLoadingOrder = false
                        this.$store.dispatch("cart/emitFbPixelPurchaseEvent", {
                            currency: response.data.currency,
                            amount: response.data.price_grandtotal
                        })
                        this.$store.dispatch('cart/teardownCart')
                        //this.hide()
                        this.$emit('order-success', response.data.id)
                    })
                    .catch(function (error) {
                        console.log('PAY WITH BANK TRANSFER ERROR', error)
                        // let errorMessageDetail = ''
                        // if (error.response) {
                        //     console.log(error.response.status)
                        //     console.log(error.response.headers)
                        //     errorMessageDetail = error.response.data.detail || error.response.data
                        // } else if (error.request) {
                        //     /*
                        //      * The request was made but no response was received, `error.request`
                        //      * is an instance of XMLHttpRequest in the browser and an instance
                        //      * of http.ClientRequest in Node.js
                        //      */
                        //     console.log('error.request', error.request)
                        //     errorMessageDetail = error.request
                        // } else {
                        //     // Something happened in setting up the request and triggered an Error
                        //     console.log('Error', error.message)
                        // }
                    })
            }
        }
    }
</script>
